import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

import Button from '../Button';

import settings from '../../config';

const VariantTransactionForm = () => {
  const navigate = useNavigate();
  const { variantId = '', transactionId = null } = useParams();
  const [variant, setVariant] = useState({});
  const [merchants, setMerchants] = useState([]);

  useEffect(() => {
    (async () => {
      const response = await axios.post(`${settings.api}variants/view`, {
        variantId
      });

      if (response.data.statusCode === 200) {
        setVariant(response.data.data[0]);
      }
    })();

    (async () => {
      const response = await axios.post(`${settings.api}merchants/`);

      if (response.data.statusCode === 200) {
        setMerchants(response.data.data);
      }
    })();
  }, [variantId]);

  useEffect(() => {
    if (transactionId) {
      (async () => {
        const response = await axios.post(
          `${settings.api}variant/view-transaction`,
          {
            transactionId
          }
        );

        setFormData(response.data.data[0]);
      })();
    }
  }, [transactionId]);

  const [formData, setFormData] = useState({
    variantId,
    merchantId: '',
    price: '',
    weight: '',
    transactionType: 1,
    transactionDate: ''
  });

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();

        const response =
          (transactionId &&
            (await axios.post(
              `${settings.api}variant/update-transaction`,
              formData
            ))) ||
          (await axios.post(
            `${settings.api}variant/create-transaction`,
            formData
          ));

        if (response.data.statusCode === 200) {
          navigate(`/variant/transactions/${variantId}`);
        }
      }}
    >
      <div className='w-full lg:w-1/2'>
        <div className='bg-white w-full rounded-xl divide-solid divide-y flex flex-col px-4'>
          <div className='flex flex-col text-sm text-gray-500 py-4'>
            <div className='flex flex-row justify-center space-x-10 w-full'>
              <div className='w-full font-bold text-xl text-center mb-5'>
                استماره معامله الخامه
              </div>
            </div>
            <div className='flex space-x-10 w-full'>
              <label className='w-full'>
                اسم الخامه
                <input
                  defaultValue={variant.variantName}
                  disabled
                  className='w-full border rounded-lg my-2 p-2 invalid:border-pink-500 invalid:text-pink-600
              focus:invalid:border-pink-500 focus:invalid:ring-pink-500'
                />
              </label>
            </div>
            <div className='flex space-x-10 w-full'>
              <label className='w-full'>
                اسم التاجر
                <select
                  value={formData.merchantId}
                  onChange={onChange}
                  className='w-full border rounded-lg my-2 p-2 invalid:border-pink-500 invalid:text-pink-600
              focus:invalid:border-pink-500 focus:invalid:ring-pink-500'
                  name='merchantId'
                  required
                >
                  <option value=''>اختر</option>
                  {merchants.map((merchant) => (
                    <option
                      key={merchant.merchantId}
                      value={merchant.merchantId}
                    >
                      {merchant.merchantName}
                    </option>
                  ))}
                </select>
              </label>
            </div>
            <div className='flex space-x-10 w-full'>
              <label className='w-full'>
                سعر الكيلو
                <input
                  placeholder='سعر الكيلو'
                  value={formData.price}
                  name='price'
                  onChange={onChange}
                  className='w-full border rounded-lg my-2 p-2 invalid:border-pink-500 invalid:text-pink-600
              focus:invalid:border-pink-500 focus:invalid:ring-pink-500'
                  required
                />
              </label>
            </div>
            <div className='flex space-x-10 w-full'>
              <label className='w-full'>
                الوزن
                <input
                  placeholder='الوزن'
                  value={formData.weight}
                  name='weight'
                  onChange={onChange}
                  className='w-full border rounded-lg my-2 p-2 invalid:border-pink-500 invalid:text-pink-600
              focus:invalid:border-pink-500 focus:invalid:ring-pink-500'
                  required
                />
              </label>
            </div>
            <div className='flex space-x-10 w-full'>
              <label className='w-full'>
                السعر الاجمالى
                <input
                  placeholder='السعر الاجمالى'
                  value={formData.price * formData.weight || 0}
                  className='w-full border rounded-lg my-2 p-2 invalid:border-pink-500 invalid:text-pink-600
              focus:invalid:border-pink-500 focus:invalid:ring-pink-500'
                  disabled
                />
              </label>
            </div>
            <div className='flex space-x-10 w-full'>
              <label className='w-full'>
                تاريخ المعامله
                <input
                  placeholder='yyyy-mm-dd'
                  value={formData.transactionDate}
                  name='transactionDate'
                  onChange={onChange}
                  className='w-full border rounded-lg my-2 p-2 invalid:border-pink-500 invalid:text-pink-600
              focus:invalid:border-pink-500 focus:invalid:ring-pink-500'
                  required
                  pattern='[0-9]{4}-[0-9]{2}-[0-9]{2}'
                />
              </label>
            </div>
            <div className='flex flex-row justify-center space-x-10 w-full mt-5'>
              <div className='w-1/2'>
                <Button
                  type='submit'
                  text='تسجيل'
                  isDisabled={
                    !(
                      formData.merchantId &&
                      formData.variantId &&
                      formData.weight &&
                      formData.transactionType &&
                      formData.transactionDate
                    )
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default VariantTransactionForm;
